import { useReCaptcha } from 'vue-recaptcha-v3';

// https://dev.to/fitrakun/integrating-nuxt-3-with-recaptcha-v3-for-token-handling-2dp0
export function useGoogleRecaptcha() {
  const recaptchaInstance = useReCaptcha();

  const executeRecaptcha = async (action) => {
    await recaptchaInstance?.recaptchaLoaded();
    const token = await recaptchaInstance?.executeRecaptcha(action);
    const headerOptions = {
      headers: {
        'google-recaptcha-token': token,
      },
    };
    return { token, headerOptions };
  };

  return { executeRecaptcha };
}
